import { GameMode } from './types';

// Map URL slugs to GameMode enum values
export const MODE_ROUTES: Record<string, GameMode> = {
  'sudden-death': GameMode.SUDDEN_DEATH,
  'standard': GameMode.STANDARD,
  'infinite-timed': GameMode.INFINITE_TIMED,
  'infinite-score': GameMode.INFINITE_SCORE,
  'question-sprint': GameMode.QUESTION_SPRINT,
  'five-for-five': GameMode.FIVE_FOR_FIVE,
  'rolling-five': GameMode.ROLLING_FIVE,
  'grid-gauntlet': GameMode.GRID_GAUNTLET,
};

// Reverse mapping: GameMode to URL slug
export const MODE_TO_SLUG: Record<GameMode, string> = {
  [GameMode.SUDDEN_DEATH]: 'sudden-death',
  [GameMode.STANDARD]: 'standard',
  [GameMode.INFINITE_TIMED]: 'infinite-timed',
  [GameMode.INFINITE_SCORE]: 'infinite-score',
  [GameMode.QUESTION_SPRINT]: 'question-sprint',
  [GameMode.FIVE_FOR_FIVE]: 'five-for-five',
  [GameMode.ROLLING_FIVE]: 'rolling-five',
  [GameMode.GRID_GAUNTLET]: 'grid-gauntlet',
};

export type AppRoute = 
  | { type: 'home' }
  | { type: 'audit' }
  | { type: 'prompt' }
  | { type: 'game'; mode: GameMode };

/**
 * Parse the current URL path into an AppRoute
 */
export function parseRoute(pathname: string): AppRoute {
  const path = pathname.replace(/^\/+|\/+$/g, ''); // Trim slashes
  
  if (path === '' || path === 'index.html') {
    return { type: 'home' };
  }
  
  if (path === 'audit') {
    return { type: 'audit' };
  }

  if (path === 'prompt') {
    return { type: 'prompt' };
  }
  
  if (path in MODE_ROUTES) {
    return { type: 'game', mode: MODE_ROUTES[path] };
  }
  
  // Unknown route, default to home
  return { type: 'home' };
}

/**
 * Navigate to a new route (updates URL without page reload)
 */
export function navigate(route: AppRoute): void {
  let path = '/';
  
  if (route.type === 'audit') {
    path = '/audit';
  } else if (route.type === 'prompt') {
    path = '/prompt';
  } else if (route.type === 'game') {
    path = `/${MODE_TO_SLUG[route.mode]}`;
  }
  
  window.history.pushState({}, '', path);
  // Dispatch a custom event so React can respond
  window.dispatchEvent(new PopStateEvent('popstate'));
}

/**
 * Get the current route from the URL
 */
export function getCurrentRoute(): AppRoute {
  return parseRoute(window.location.pathname);
}
